import React, { useState, useEffect, StrictMode, useCallback, useMemo, useRef } from 'react';
import '../App.css'; // Adjust the CSS import path
import { AgGridReact } from 'ag-grid-react';
import { createRoot } from "react-dom/client";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { baseUrl } from '../shared';
import axios from "axios";
import { useGlobalState } from '../state';
import CustomButtonComponent from './customButtonComponent';
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import Header from './Header';
import { Accordion, Placeholder } from 'rsuite';
import { useNavigate } from "react-router-dom";
import Popup from './popup';
import { useAuth } from './useAuth';
import "rsuite/dist/rsuite.css";
import Support from "./Support"
import LionAssessment from './LionAssessment';
import Codes from './Codes';
import News from './News';
import Schedule from './Schedule';
import Results from './Results';
import StudentResults from './StudentResults'
import Assignments from './Assignments';
import Assessments from './Assessments';
import AcceleratedLearning from "./AcceleratedLearning";
import ReportCard from "./Dashboard";
ModuleRegistry.registerModules([ClientSideRowModelModule]);


const usePreventBackNavigation = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      // If the user is not authenticated, redirect them to the login page.
      navigate('/');
    }
  }, [isAuthenticated, navigate]);
};


function MainContent({ activeTab, DOB,setStudentInfo  }) {
  usePreventBackNavigation();
  // Global State for Subject Selection
  const [selectedSubject, setSelectedSubject] = useState('All');
  const [seAccessReadOnly] = useGlobalState("SEAccessReadOnly");
  const news = require('../menu_icons/news.png');
  const assessment = require('../menu_icons/etazo.png');

  const lion = require('../icons/LionIcon.png');
  const result = require('../menu_icons/results.png');

  const assignment = require('../menu_icons/assignment.png');
  const schedule = require('../menu_icons/schedule.png');

  const codes = require('../menu_icons/codes.png');
  const help = require('../menu_icons/support.png');
  const all = require('../icons/ALL.png');
  const TEKSReport = require('../menu_icons/TEKS.png')

  const Accelerated_Learning = require('../menu_icons/acceleratedlearning.png');
  // Assignments States
  const [searchTermAssignments, setSearchTermAssignments] = useState('');
  const [sortOrderAssignments, setSortOrderAssignments] = useState({ column: 'dueDate', order: 'asc' });
  const [currentPageAssignments, setCurrentPageAssignments] = useState(1);
  const rowsPerPageAssignments = 5;

  // Data for Assignments
  const assignmentsData = [
    { dueDate: '09/10/2024', title: 'Math Homework 1', subject: 'Math', description: 'Complete Chapter 1 exercises', status: 'Incomplete' },
    { dueDate: '09/15/2024', title: 'Science Project', subject: 'Science', description: 'Prepare a volcano model', status: 'Submitted' },
    { dueDate: '09/12/2024', title: 'RLA Essay', subject: 'RLA', description: 'Write a 1000-word essay', status: 'Upcoming' },
    { dueDate: '09/09/2024', title: 'Social Studies Quiz Prep', subject: 'Social Studies', description: 'Review chapter 2 for quiz', status: 'Today' },
    { dueDate: '09/20/2024', title: 'Art Portfolio', subject: 'Art', description: 'Compile your best artworks', status: 'Incomplete' },
    // Add more assignments as needed...
  ];


  const [rowData, setRowData] = useState([]);
  const [codesModule, setCodesModule] = useState([]);
  const [languageList, setLangList] = useState([]);
  let [resultModule, setResultModule] = useState([]);
  const [loadingResults, setLoadingResults] = useState(true);
  const [currentGradingPeriod, setcurrentGradingPeriod] = useState();
  const [acceleratedLearningData, setAcceleratedLearningData] = useState([]);
  const [studntIdData, setstudntIdData] = useState();
  const [StudentName, setStudentName] = useState();
  let [assessmentDetails, setassessmentDetails] = useState([]);
  const [assessmentDetailsFilter, setassessmentDetailsFilter] = useState([]);
  const [subjectForAssessment, setsubjectForAssessment] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupData, setpopupData] = useState([]);
  const [checkTime, setcheckTime] = useState(true);
  const [isPopupError, setIsPopupError] = useState(false);
  const [assesssmentCodeval, setassesssmentCodeVal] = useState('');
  const [lionResult1, setLionResult1] = useState([]);
  const [lionResult2, setLionResult2] = useState([]);
  const [assessmentResult, setassessmentResult] = useState([]);
  const [lionActiveTab, setlionActiveTab] = useState([]);
  const [yearFilter, setYearFilter] = useState([]);
  const [currectYear, setCurrentYear] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState("KENTRO");
  const [productList, setProductList] = useState([]);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [assessmentResultByItem, setassessmentResultByItem] = useState([]);
  const [assessmentDetail, setassessmentDetail] = useState(null);
  const [getDOB, setDOB] = useState();

  useEffect(() => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
      'Content-Type': 'application/json', // Optional: Define the content type if needed
    };
    setLoadingResults(true);
    
    document.querySelector('.sidebar').classList.add('sidebarDisable');

    if (token != null) {
      axios.get(baseUrl + `Student/GetStudentResult?studentkey=${studentkey}&districtId=${districtID}`, { headers })
        .then(res => {
          setStudentInfo(res.data);
          const resultData = res.data.data4
          setRowData(resultData);
          //setResultModule(res.data.resultData);
          setassessmentResult(res.data.resultData)
          setCodesModule(res.data.data1);
          setLangList(res.data.data9);
          setAcceleratedLearningData(res.data.data10);
          setstudntIdData(res.data.data2[0].StudentId);
          setDOB(res.data.data2[0].DOB)
          setStudentName(res.data.data1[0].FullName);
          setLionResult1(res.data)
          setLionResult2(Array.isArray(res.data.lionRes1) ? res.data.lionRes1 : [])
          setlionActiveTab(res.data.inSeasonValue);
          setLoadingResults(false);
          document.querySelector('.sidebar').classList.remove('sidebarDisable');

          let AssessmentData = res.data.data5;
          let newKey = 'status';
          let arr = ["All"]; 
          const map = new Map();
          AssessmentData.forEach(item => {
            item[newKey] = "";
            const key = `${item.Subject}-${item.ColorIcon}`;

            if (!map.has(key)) {
              map.set(key, { subject: item.Subject, icon: item.ColorIcon });
            }
          });

          arr = Array.from(map.values());

          arr.unshift({ subject: "All" });

          arr.sort((a, b) => {
            if (a.subject === "All") return -1;
            if (b.subject === "All") return 1;
            return a.subject.localeCompare(b.subject);
          });
          console.log(arr);
          setsubjectForAssessment(arr);

          let product = [];
          let resultDataProduct = res.data.resultData;
          const uniqueProduct = [
            ...new Set(resultDataProduct.map((item) => item.Product)),
          ];
          if(uniqueProduct.length > 0){
            uniqueProduct.push('Details');
          }
          if(!uniqueProduct.includes("KENTRO"))
          {
            setSelectedProduct(uniqueProduct[0]);
          }
          setProductList(uniqueProduct);
          if(uniqueProduct.length > 0){
          uniqueProduct.push('Details');
          }
          let resultYearFilter = res.data.resultData;
          let yearArr = [];
          let currentSelectedYear = null;
          resultYearFilter.forEach(item => {
            if (item.CurrentYear == 1) {
              currentSelectedYear = item.SchoolYear;
            }
            yearArr = [...new Set([...yearArr, item.SchoolYear])];
          });
          yearArr.sort();
          yearArr.reverse();
          setCurrentYear(currentSelectedYear);
          setYearFilter(yearArr)

          const currentYearResult = [];
          for (const item of res.data.resultData) {
            if (item.SchoolYear == currentSelectedYear) 
              {
              currentYearResult.push(item);
            }
          }
          setResultModule(currentYearResult);
          const today = new Date(); // Get current date

          const month = today.getMonth() + 1; // getMonth() returns 0-11, so add 1
          const day = today.getDate(); // getDate() returns the day of the month
          const year = today.getFullYear(); // getFullYear() returns the full year

          // Format month, day to ensure they have two digits (e.g., 01, 02)
          const formattedMonth = month < 10 ? '0' + month : month;
          const formattedDay = day < 10 ? '0' + day : day;

          // Return the formatted date in month-day-year format


          const parseDate = (dateStr) => {
            const [month, day, year] = dateStr.split('-');
            return new Date(`${year}-${month}-${day}`); // Convert to yyyy-mm-dd
          };
          let date1 = `${formattedMonth}-${formattedDay}-${year}`;
          const utc = parseDate(date1);
          AssessmentData.forEach(item => {
            const releaseDate = parseDate(item.ReleaseDate); // Second date (month-day-year format)
            if (item.Complete == 1) {
              item.status = "Incomplete"
            }
            else if (item.Complete == 2) {
              item.status = "Complete"
            }
            else if (releaseDate > utc && item.Complete == 0) {
              item.status = "Upcoming"
            }
            else if (releaseDate.getTime() == utc.getTime() && item.Complete == 0) {
              item.status = "Today"
            }
            else {
              item.status = "Pending"
            }
          });
          setassessmentDetails(AssessmentData);
          setassessmentDetailsFilter(AssessmentData)
          const categories1 = {};
          for (const item of resultData) {
            if (item.PeriodName in categories1) {
              categories1[item.PeriodName].push(item);
            } else {
              categories1[item.PeriodName] = [item];
            }
          }
          (Object.keys(categories1).forEach(function (value, key) {
            for (const item of categories1[value]) {
              if (item.Current == true) {
                setcurrentGradingPeriod(key);
                break;
              }
            }
          }));

        })
        .catch(() => setLoadingResults(false));
    }

  }, []);


  const colDefs = useMemo(() => {
    return [
      {
        field: 'actions',
        headerName: 'Actions',
        cellRenderer: CustomButtonComponent,
      },
      { field: "ClassKey", hide: true, },
      { field: "Current", hide: true },
      { field: "Description" },
      { field: "FirstName" },
      { field: "LastName" },
      { field: "Period" },
      { field: "PeriodName" },
      { field: "SchoolNameAbbrv" },
      { field: "TeacherKey", hide: true, },
    ];
  });

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 150,
      filter: true,
      floatingFilter: true,
    };
  }, []);


  const categories = {};
  for (const item of rowData) {
    if (item.PeriodName in categories) {
      categories[item.PeriodName].push(item);
    } else {
      categories[item.PeriodName] = [item];
    }
  }

  const assessmentList = {};
  for (const item of assessmentDetails) {
    if (item.status in assessmentList) {
      assessmentList[item.status].push(item);
    } else {
      assessmentList[item.status] = [item];
    }
  }

  const lionAssessmentList = {};
  for (const item of lionResult2) {
    if (item.Season in lionAssessmentList) {
      lionAssessmentList[item.Season].push(item);
    } else {
      lionAssessmentList[item.Season] = [item];
    }
  }

  const resultDataSet = {};
  for (const item of resultModule) {
    if (item.Subject in resultDataSet) {
      resultDataSet[item.Subject].push(item);
    } else {
      resultDataSet[item.Subject] = [item];
    }
  }



  const newReultData = {};

  Object.keys(resultDataSet).forEach(function (value, key) {
    const AsmtCatg = {};
    for (const item of resultDataSet[value]) {
      if (item.AsmtCatg in AsmtCatg) {
        AsmtCatg[item.AsmtCatg].push(item);
      }
      else {
        AsmtCatg[item.AsmtCatg] = [item];
      }
    }
    if (value in newReultData) {

    }
    else {
      newReultData[value] = AsmtCatg
    }

  });


  // Subject Selection Handler
  const handleSubjectSelection = (subject) => {
    setSelectedSubject(subject);
    // Reset pagination and search when subject changes
    setCurrentPageAssignments(1);
    setSearchTermAssignments('');

    assessmentDetails = assessmentDetailsFilter;
    let myArray = assessmentDetails;
    if (subject != "All") {
      let targetArray = [];
      for (let i = 0; i < myArray.length; i++) {
        if (myArray[i].Subject === subject) {
          targetArray.push(myArray[i]); // Add to targetArray if type matches "fruit"
        }
      }
      setassessmentDetails(targetArray);
    }
    else {
      setassessmentDetails(assessmentDetails);
    }

  };

  // Subject Selection Handler
  const handleSelectedYear = (e) => {
    let year = e.target.value;
    setCurrentYear(year);

    resultModule = assessmentResult;
    let myArray = resultModule;
    let targetArray = [];
    for (let i = 0; i < myArray.length; i++) {
      if (myArray[i].SchoolYear === year) {
        targetArray.push(myArray[i]); // Add to targetArray if type matches "fruit"
      }
    }
    setResultModule(targetArray);

  };

  const handleClick = (item) => {
    // Check if access is read-only
    const isReadOnly = seAccessReadOnly || sessionStorage.getItem("SEAccessReadOnly") === "true";
    if (isReadOnly) {
      return; // Don't open popup if read-only
    }
    setpopupData(item);
    setcheckTime(true);
    setIsPopupOpen(true);
    setIsPopupError(false);
  };
  const closePopup = () => {
    setassesssmentCodeVal('');
    setIsPopupOpen(false);
  };

  const handleChangeInput = (e) => {
    setassesssmentCodeVal(e.target.value); // Update parent state with new input value
  };

  const etazoAutoLogin = (item) => {
    setIsPopupError(false)
    if (assesssmentCodeval.toUpperCase() == item.AssessmentCode.toUpperCase()) {
      let checkTiming = compareTimes(item.StartTime, item.EndTime)
      setcheckTime(checkTiming)
      if (checkTiming) {
        setassesssmentCodeVal('');
        let districtID = sessionStorage.getItem("districtID");
        let assessmentID = item.AssessmentCode + "Bypass";
        let studentID = studntIdData;
        let currentdate = new Date();
        let datetime = currentdate.getFullYear() + "-"
          + (currentdate.getMonth() + 1) + "-"
          + currentdate.getDate() + " "
          + currentdate.getHours() + ":"
          + currentdate.getMinutes() + ":"
          + currentdate.getSeconds();

        let BirthDate = getDOB.split("-");
        if (item.DOBAuthentication) {
          let a = document.createElement('a');
          a.target = '_blank';
          a.href = 'https://etazo.tangosoftware.com/EtazoLogin/AutoStudentOnlineLogin?DistrictID=' + districtID + '&AssessmentID=' + assessmentID + '&StudentID=' + studentID + '&ClientTime=' + datetime + '&month=' + BirthDate[0] + '&day=' + BirthDate[1] + '&year=' + BirthDate[2];
          a.click();
        }
        else {
          if (item.BubbleSheet) {
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = 'https://etazo.tangosoftware.com/EtazoLogin/AutoStudentLogin?DistrictID=' + districtID + '&AssessmentID=' + assessmentID + '&StudentID=' + studentID + '&ClientTime=' + datetime;
            a.click();
          }
          else {
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = 'https://etazo.tangosoftware.com/EtazoLogin/AutoStudentOnlineLogin?DistrictID=' + districtID + '&AssessmentID=' + assessmentID + '&StudentID=' + studentID + '&ClientTime=' + datetime;
            a.click();
          }
        }
        setIsPopupOpen(false);
      }
      else {
        setcheckTime(checkTiming)
      }

    }
    else {
      setIsPopupError(true)
    }


  }

  function compareTimes(time1, time2) {
    // Convert time strings to Date objects for comparison
    var currentDate = new Date(); // Use current date to make sure the date part is the same
    var time1Parts = time1.split(':'); // Split time1 into hours, minutes, and seconds
    var time2Parts = time2.split(':'); // Split time2 into hours, minutes, and seconds

    // Set hours, minutes, and seconds for both times, while keeping the current date
    currentDate.setHours(time1Parts[0], time1Parts[1], time1Parts[2]);
    var dateTime1 = currentDate.getTime(); // Get time in milliseconds

    currentDate.setHours(time2Parts[0], time2Parts[1], time2Parts[2]);
    var dateTime2 = currentDate.getTime(); // Get time in milliseconds

    var currentNewDate = new Date();
    var compareDate = currentNewDate.getTime(); // Get time in milliseconds

    // Compare times
    if (compareDate >= dateTime1 && compareDate <= dateTime2) {
      return true;
    } else {
      return false;
    }
  }

  // -------------------- Render Subject Row -------------------- //
  
  const renderSubjectRow = () => {
    const subjects = subjectForAssessment;

    return (
      <div className="subject-row">
        {subjects.map(({ subject, icon }) => (
          <button
            key={subject}
            className={`subject-button ${selectedSubject === subject ? 'active' : ''}`}
            onClick={() => handleSubjectSelection(subject)}
          >
            {subject !== "ALL" && icon ? (
              <img src={icon} alt={`${subject} icon`} className="subject-icon" />
            ) : (
              <img src={all}  alt="No icon" className="subject-icon" />
            )}
            {subject}
          </button>
        ))}
      </div>
    );
  };

  const renderCurrentYear = () => {
    const years = yearFilter // Add more subjects as needed

    return (
      <div className="form-group" style={{ marginBottom: '15px', marginLeft: "10px" }}>
        <label htmlFor="schoolYear" style={{ fontWeight: 'bold' }}>School Year :</label>
        <select
          id="schoolYear"
          value={currectYear}
          onChange={(e) => handleSelectedYear(e)}
          style={{ maxWidth: '300px', padding: '8px', marginLeft: '10px', borderRadius: "5px" }}
        >
          {years.map((year, index) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      // <div className="subject-row">
      //   {years.map((year) => (
      //     <button
      //       key={year}
      //       className={`subject-button ${currectYear === year ? 'active' : ''}`}
      //       onClick={() => handleSelectedYear(year)}
      //     >
      //       {year}
      //     </button>
      //   ))}
      // </div>
    );
  };

  const getProductList = (product) => {
    const detailsButton = document.querySelector('.Details');
    if (detailsButton) {
      detailsButton.style.display = "none";
    }
    setSelectedProduct(product)

    const productData = assessmentResult.filter((entry) => entry.Product === product);
    const availableYears = productData.map((entry) => entry.SchoolYear);

    if (!availableYears.includes(currectYear)) {
      const closestYear = availableYears.sort((a, b) => b.localeCompare(a))[0];
      handleSelectedYear({ target: { value: closestYear } });  
    }
  };

  const handleClickResult = async (item) => {
    const detailsButton = document.querySelector('.Details');
    if (detailsButton) {
      detailsButton.style.display = "inline-block";
    }
    setassessmentDetail(item)
    setSelectedProduct("Details")
    setSelectedItem(item);
    setLoadingDetail(true);
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      "Content-Type": "application/json", // Optional: Define the content type if needed
    };
    if (token != null) {
      try {
        const response = await axios.get(
          baseUrl +
          `Student/GetItemAnalysisForAssessment?studentkey=${studentkey}&assessmentKey=${item.IbeReleaseKey}&districtId=${districtID}`,
          { headers }
        );
        setassessmentResultByItem(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingDetail(false);
      }
    }
  };

  const handleClickLIONResult = async (item) => {
    const detailsButton = document.querySelector('.Details');
    if (detailsButton) {
      detailsButton.style.display = "inline-block";
    }
    setassessmentDetail(item)
    setSelectedProduct("Details")
    setSelectedItem(item);
    setLoadingDetail(true);
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      "Content-Type": "application/json", // Optional: Define the content type if needed
    };
    if (token != null) {
      try {
        const response = await axios.get(
          baseUrl +
          `Student/GetLIONResultDetail?studentkey=${studentkey}&lionResultID=${item.LionResultsID}&districtId=${districtID}`,
          { headers }
        );
        setassessmentResultByItem(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingDetail(false);
      }
    }
  };

  // -------------------- Main Render -------------------- //

  return (
    <div className="main-content">
      {/* Subject Row */}


      {/* Conditional Rendering based on Active Tab */}
      {activeTab === 'news' && (
        <div>
          <div class="title-container">
            <img src={news} height={28} width={28} />
            <h2 class="title-text">News</h2>
          </div>
          <News
            activeTab={activeTab}
            baseUrl={baseUrl}
          />
        </div>
      )}

      {activeTab === 'assessments' && (
        <div>
          <div class="title-container">
            <img src={assessment} height={28} width={28} />
            <h2 class="title-text">Assessments</h2>
          </div>
          {renderSubjectRow()}
          <Assessments
            assessmentList={assessmentList}
            loadingResults={loadingResults}
            handleClick={handleClick}
            activeTab={activeTab}
            baseUrl={baseUrl}
          />
        </div>
      )}

      {activeTab === 'assignments' && (
        <div>
          <div class="title-container">
            <img src={assignment} height={28} width={28} />
            <h2 class="title-text">Assignments</h2>
          </div>
          <Assignments
            assignmentsData={assignmentsData}
            searchTermAssignments={searchTermAssignments}
            setSearchTermAssignments={setSearchTermAssignments}
            currentPageAssignments={currentPageAssignments}
            setCurrentPageAssignments={setCurrentPageAssignments}
            rowsPerPageAssignments={rowsPerPageAssignments}
            sortOrderAssignments={sortOrderAssignments}
            setSortOrderAssignments={setSortOrderAssignments}
            activeTab={activeTab}
            baseUrl={baseUrl}
            lionResource={JSON.stringify(lionResult1)}
          />
        </div>
      )}

      {activeTab === 'results' && (
        <div>
          <div class="title-container">
            <img src={result} height={28} width={28} />
            <h2 class="title-text">Results</h2>
          </div>
          <StudentResults
            rowData={rowData}
            newReultData={newReultData}
            colDefs={colDefs}
            defaultColDef={defaultColDef}
            loadingResults={loadingResults}
            activeTab={activeTab}
            baseUrl={baseUrl}
            resultData={resultModule}
            yearFilter={yearFilter}
            currentYear={currectYear}
            setCurrentYear={setCurrentYear}
            handleSelectedYear={handleSelectedYear}
            selectedProduct={selectedProduct}
            productList={productList}
            getProductList={getProductList}
            handleClickResult={handleClickResult}
            selectedItem={selectedItem}
            loadingDetail={loadingDetail}
            assessmentResultByItem={assessmentResultByItem}
            assessmentDetail={assessmentDetail}
            handleClickLIONResult={handleClickLIONResult}
            DOB={getDOB}
            studntIdData={studntIdData}
          />
        </div>
      )}

      {activeTab === 'schedule' && (
        <div>
          <div class="title-container">
            <img src={schedule} height={28} width={28} />
            <h2 class="title-text">Schedule</h2>
          </div>
          <Schedule
            categories={categories}
            currentGradingPeriod={currentGradingPeriod}
            activeTab={activeTab}
            baseUrl={baseUrl}
          />
        </div>
      )}

      {activeTab === 'codes' && (
        <div>
          <div class="title-container">
            <img src={codes} height={28} width={28} />
            <h2 class="title-text">Codes</h2>
          </div>
          <Codes
            codesModule={codesModule}
            languageList={languageList}
            activeTab={activeTab}
            baseUrl={baseUrl}
          />
        </div>
      )}

      {activeTab === 'lion' && (
        <div>
          <div class="title-container">
            <img src={lion} height={28} width={28} />
            <h2 class="title-text">LION</h2>
          </div>
          <LionAssessment
            loadingResults={loadingResults}
            studntIdData={studntIdData}
            StudentName={StudentName}
            districtName={sessionStorage.getItem("DistrictName")}
            districtID={sessionStorage.getItem("districtID")}
            baseUrl={baseUrl}
            lionResult1={JSON.stringify(lionResult1)}
            activeTab={activeTab}
            lionAssessmentList={lionAssessmentList}
            lionActiveTab={lionActiveTab}
          />
        </div>
      )}

        {activeTab === 'reports' && (
        <div>
        <div class="title-container">
        <img src={TEKSReport} height={28} width={28} />
        <h2 class="title-text">TEKS Tracker</h2>
        </div>
        <ReportCard
        baseUrl={baseUrl}
        subjectForAssessment={subjectForAssessment}
        activeTab={activeTab}
        />
        </div>
        )}

      {activeTab === 'Support' && (
        <div>
          <div class="title-container">
            <img src={help} height={28} width={28} />
            <h2 class="title-text">Support</h2>
          </div>
          <Support
            studntIdData={studntIdData}
            StudentName={StudentName}
            districtName={sessionStorage.getItem("DistrictName")}
            districtID={sessionStorage.getItem("districtID")}
            baseUrl={baseUrl}
            categories={categories}
            activeTab={activeTab}
          />
        </div>
      )}

      {activeTab === 'acceleratedLearning' && (
        <div>
          <div class="title-container">
            <img src={Accelerated_Learning} height={28} width={28} />
            <h2 class="title-text">Accelerated Learning</h2>
          </div>
          <AcceleratedLearning
            acceleratedLearningData={acceleratedLearningData}
            loadingResults={loadingResults}
            activeTab={activeTab}
            baseUrl={baseUrl}
          />
        </div>
      )}
      <Popup isOpen={isPopupOpen} onClose={closePopup} etazoLogin={etazoAutoLogin} item={popupData} time={checkTime} isError={isPopupError} onChange={handleChangeInput} assesssmentCodeval={assesssmentCodeval} />

      {/* Background overlay to block interactions */}
      {isPopupOpen && <div className="overlay"></div>}
    </div>
  );
}

export default MainContent;
